// Date example
import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { Formatter } from "@stamhoofd/utility";
import { Filter, FilterDefinition } from "./FilterDefinition";
export class RegistrationsFilterChoice extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        /**
         * Whether registrations on waiting lists count or not (or doesn't matter = null)
         */
        this.waitingList = false;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], RegistrationsFilterChoice.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegistrationsFilterChoice.prototype, "name", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], RegistrationsFilterChoice.prototype, "waitingList", void 0);
export var RegistrationsFilterMode;
(function (RegistrationsFilterMode) {
    RegistrationsFilterMode["Or"] = "Or";
    RegistrationsFilterMode["And"] = "And";
    /**
     * Means !(A || B) == !A && !B
     */
    RegistrationsFilterMode["Nor"] = "Nor";
    /**
     * Means !(A && B) == !A || !B
     */
    RegistrationsFilterMode["Nand"] = "Nand";
})(RegistrationsFilterMode || (RegistrationsFilterMode = {}));
/**
 * RegistrationsFilter is used because the available groups don't need to be encoded and can change without breaking the encoding/decoding
 */
export class RegistrationsFilterDefinition extends FilterDefinition {
    getChoices(organization) {
        const choices = [];
        for (const group of organization.adminAvailableGroups) {
            choices.push(RegistrationsFilterChoice.create({
                id: group.id,
                waitingList: false,
                name: group.settings.name
            }));
        }
        return choices;
    }
    decode(data) {
        var _a, _b, _c, _d;
        const filter = new RegistrationsFilter();
        filter.definition = this;
        filter.choices = (_b = (_a = data.optionalField("choices")) === null || _a === void 0 ? void 0 : _a.array(RegistrationsFilterChoice)) !== null && _b !== void 0 ? _b : [];
        filter.mode = (_d = (_c = data.optionalField("mode")) === null || _c === void 0 ? void 0 : _c.enum(RegistrationsFilterMode)) !== null && _d !== void 0 ? _d : RegistrationsFilterMode.Or;
        return filter;
    }
    createFilter() {
        const filter = new RegistrationsFilter();
        filter.definition = this;
        filter.mode = RegistrationsFilterMode.Or;
        return filter;
    }
}
export class RegistrationsFilter extends Filter {
    constructor() {
        super(...arguments);
        this.choices = [];
        this.mode = RegistrationsFilterMode.Or;
    }
    doesMatch(object) {
        if (this.choices.length === 0) {
            // Empty filter does not filter
            return true;
        }
        const choices = this.definition.getValue(object);
        for (const choice of this.choices) {
            if (choices.find(c => c.id == choice.id)) {
                if (this.mode === RegistrationsFilterMode.Or) {
                    return true;
                }
                if (this.mode === RegistrationsFilterMode.Nor) {
                    return false;
                }
            }
            else {
                if (this.mode === RegistrationsFilterMode.Nand) {
                    return true;
                }
                if (this.mode === RegistrationsFilterMode.And) {
                    return false;
                }
            }
        }
        return this.mode === RegistrationsFilterMode.And || this.mode === RegistrationsFilterMode.Nor;
    }
    encode(context) {
        return {
            definitionId: this.definition.id,
            choices: this.choices.map(c => c.encode(context)),
            mode: this.mode
        };
    }
    toString() {
        switch (this.mode) {
            case RegistrationsFilterMode.Or:
                return "Is ingeschreven voor " + Formatter.joinLast(this.choices.map(c => c.name), ", ", " of ");
            case RegistrationsFilterMode.And:
                return "Is ingeschreven voor zowel " + Formatter.joinLast(this.choices.map(c => c.name), ", ", " als ");
            case RegistrationsFilterMode.Nand:
                return Formatter.capitalizeFirstLetter(Formatter.joinLast(this.choices.map(c => 'niet ingeschreven voor ' + c.name), ", ", " of "));
            case RegistrationsFilterMode.Nor:
                return Formatter.capitalizeFirstLetter(Formatter.joinLast(this.choices.map(c => 'niet ingeschreven voor ' + c.name), ", ", " en "));
        }
    }
    get inverted() {
        const filter = this.clone();
        if (filter.mode === RegistrationsFilterMode.And) {
            filter.mode = RegistrationsFilterMode.Nand;
        }
        else if (filter.mode === RegistrationsFilterMode.Nand) {
            filter.mode = RegistrationsFilterMode.And;
        }
        else if (filter.mode === RegistrationsFilterMode.Or) {
            filter.mode = RegistrationsFilterMode.Nor;
        }
        else if (filter.mode === RegistrationsFilterMode.Nor) {
            filter.mode = RegistrationsFilterMode.Or;
        }
        return filter;
    }
}
//# sourceMappingURL=RegistrationsFilter.js.map